// Service RTK Query da tela "Visão Geral Agro" — 5 rotas GET proxy 1:1 do
// WSGI (contrato: espaco-exclusivo-wsgi-beta/docs/contracts/agro-overview.md).
// product_key do produto 'agro' como as demais rotas agro (DECISÃO-12).
import baseApi from 'services/api/base';
import getProductKey from 'helper/requests/getProductKey';
import {
  transformGetAgroOverviewKpisResponse,
  transformGetAgroOverviewMapaResponse,
  transformGetAgroOverviewMapaVariaveisResponse,
  transformGetAgroOverviewTabelaResponse,
  transformGetAgroOverviewTabelaVariaveisResponse,
} from 'helper/Meteorology/Agro/Overview';
import {
  AgroOverviewLocationsData,
  AgroOverviewMapData,
  AgroOverviewMapVariable,
  AgroOverviewSummary,
  AgroOverviewTableVariable,
  AgroOverviewVariable,
} from 'types/Meteorology/Agro/Overview/Dashboard';

export const agroOverviewApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getAgroOverviewKpis: build.query<AgroOverviewSummary, void>({
      query: () => {
        const productKey = getProductKey('agro');
        return {
          url: `produtos/agro/visao-geral/kpis?product_key=${productKey}`,
          method: 'GET',
        };
      },
      transformResponse: transformGetAgroOverviewKpisResponse,
      // KPIs dos cards 3-4 dependem dos locais do usuário: refaz após CRUD.
      providesTags: ['AgroLocations'],
    }),
    getAgroOverviewMap: build.query<AgroOverviewMapData, AgroOverviewVariable>({
      query: (variavel) => {
        const productKey = getProductKey('agro');
        return {
          url: `produtos/agro/visao-geral/mapa?product_key=${productKey}&variavel=${variavel}`,
          method: 'GET',
        };
      },
      transformResponse: transformGetAgroOverviewMapaResponse,
    }),
    getAgroOverviewTable: build.query<AgroOverviewLocationsData, void>({
      query: () => {
        const productKey = getProductKey('agro');
        return {
          url: `produtos/agro/visao-geral/tabela?product_key=${productKey}`,
          method: 'GET',
        };
      },
      transformResponse: transformGetAgroOverviewTabelaResponse,
      providesTags: ['AgroLocations'],
    }),
    getAgroOverviewTableVariables: build.query<AgroOverviewTableVariable[], void>({
      query: () => {
        const productKey = getProductKey('agro');
        return {
          url: `produtos/agro/visao-geral/tabela/variaveis?product_key=${productKey}`,
          method: 'GET',
        };
      },
      transformResponse: transformGetAgroOverviewTabelaVariaveisResponse,
    }),
    getAgroOverviewMapVariables: build.query<AgroOverviewMapVariable[], void>({
      query: () => {
        const productKey = getProductKey('agro');
        return {
          url: `produtos/agro/visao-geral/mapa/variaveis?product_key=${productKey}`,
          method: 'GET',
        };
      },
      transformResponse: transformGetAgroOverviewMapaVariaveisResponse,
    }),
  }),
});

export const {
  useGetAgroOverviewKpisQuery,
  useGetAgroOverviewMapQuery,
  useGetAgroOverviewTableQuery,
  useGetAgroOverviewTableVariablesQuery,
  useGetAgroOverviewMapVariablesQuery,
} = agroOverviewApi;
